import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Leaf, Droplets, Coffee } from 'lucide-react';

const products = [
  {
    id: 'kesar',
    name: 'Hind Harvest Kashmiri Kesar',
    subtitle: 'Grade-1 Kashmiri Saffron',
    description:
      'Pure, handpicked saffron from the fields of Pampore, Kashmir. Known for its deep colour, rich aroma and potent goodness — carefully packed to preserve every strand.',
    image:
      'https://customer-assets-7cd3h4nn.emergentagent.net/job_828e32ce-193c-4c51-b926-dcf4aea89e6f/artifacts/ocion9gb_WhatsApp%20Image%202026-07-24%20at%2010.45.41%20AM.jpeg',
    link: '/products/kesar',
    badge: 'Available Now',
    available: true,
  },
];

const upcomingProducts = [
  { name: 'Honey', icon: Droplets, desc: 'Pure, raw honey from select Indian apiaries.' },
  { name: 'Dry Fruits', icon: Leaf, desc: 'Premium nuts and dried fruits from trusted farms.' },
  { name: 'Tea', icon: Coffee, desc: 'Handpicked single-origin Indian teas.' },
];

const Products = () => {
  return (
    <div className="pt-16 sm:pt-20">
      {/* Header Section */}
      <section className="bg-gradient-to-br from-saffron-50 to-cream-100 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" data-testid="products-page-title">
              Our Products
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Discover our carefully curated selection of premium FMCG products from India
            </p>
          </div>
        </div>
      </section>

      {/* Featured Product — Kesar */}
      <section className="py-12 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Product Image */}
            <div className="order-2 lg:order-1">
              <div className="relative">
                <img
                  src={products[0].image}
                  alt={products[0].name}
                  className="rounded-2xl shadow-2xl w-full object-contain bg-cream-100"
                  data-testid="kesar-product-image"
                />
                <div className="absolute -bottom-5 right-0 sm:-right-5 bg-saffron-600 text-white px-5 py-2.5 rounded-xl shadow-lg">
                  <p className="text-sm font-semibold">100% Pure</p>
                </div>
              </div>
            </div>

            {/* Product Details */}
            <div className="order-1 lg:order-2">
              <div className="inline-block bg-saffron-100 text-saffron-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                Featured Product
              </div>
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2" data-testid="kesar-product-title">
                {products[0].name}
              </h2>
              <p className="text-base text-gray-500 mb-5">{products[0].subtitle}</p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                {products[0].description}
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to={products[0].link}
                  className="inline-flex items-center justify-center px-8 py-4 bg-saffron-600 text-white font-semibold rounded-lg hover:bg-saffron-700 transition-all duration-300 hover:shadow-lg hover:scale-105"
                  data-testid="explore-kesar-btn"
                >
                  Explore Kesar
                  <ArrowRight className="ml-2" size={20} />
                </Link>
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center px-8 py-4 bg-white border-2 border-saffron-600 text-saffron-600 font-semibold rounded-lg hover:bg-saffron-50 transition-all duration-300"
                  data-testid="contact-pricing-btn"
                >
                  Contact Us for Pricing
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Coming Soon Section */}
      <section className="py-12 sm:py-20 bg-cream-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">Expanding Our Range</h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We&#8217;re working to bring you more premium FMCG products from India&#8217;s rich
              agricultural heritage. Stay tuned for exciting new additions.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-testid="upcoming-products-grid">
            {upcomingProducts.map(({ name, icon: Icon, desc }) => (
              <div
                key={name}
                className="bg-white rounded-2xl p-8 text-center shadow-sm border border-cream-200"
              >
                <div className="w-14 h-14 mx-auto rounded-full bg-saffron-50 flex items-center justify-center mb-5">
                  <Icon size={24} className="text-saffron-600" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">{name}</h4>
                <p className="text-sm text-gray-500 leading-relaxed">{desc}</p>
                <span className="inline-block mt-4 text-xs font-medium text-saffron-600 bg-saffron-50 px-3 py-1 rounded-full">
                  Coming Soon
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;
